import Button from "./Button";
import {agent} from "../api/agent";


interface Props {

}


export default function Settings({}: Props) {
    return (
        <div>
            <h1>Settings</h1>
            <p>Settings page is under construction.</p>
            <Button onClick={() => {
                agent.rescan().then(value => {
                    console.log('Rescan initiated:', value);
                });
            }}>Rescan</Button>
        </div>
    );
}